import { createRoot } from 'react-dom/client';
import { LicenseInfo, muiXTelemetrySettings } from '@mui/x-license';
import { AuthProtection } from '@cbridge-packages/auth';
import { UserSettingsGate } from '@cbridge-packages/user-settings';
import { ErrorBoundary } from '@cbridge-tools/error-boundary';
import { initI18n } from './i18n/config';
import { LanguageSync } from './i18n/_components/LanguageSync';
import { StoreProvider } from './_store/StoreProvider';
import { makeStore } from './_store/makeStore';
import { Router } from './router/Router';

LicenseInfo.setLicenseKey(process.env['MUI_X_LICENSE_KEY']);
muiXTelemetrySettings.disableTelemetry();

window.addEventListener('vite:preloadError', () => {
  window.location.reload();
});

async function enableMocking(): Promise<void> {
  if (!import.meta.env['VITE_MOCK_API']) return;
  const { worker } = await import('../../../.mock/browser');
  await worker.start({ onUnhandledRequest: 'warn' });
}

async function bootstrap() {
  await initI18n();
  await enableMocking();
  const store = await makeStore();

  createRoot(document.getElementById('root')!).render(
    <ErrorBoundary>
      <StoreProvider store={store}>
        <AuthProtection>
          <UserSettingsGate>
            <LanguageSync>
              <Router />
            </LanguageSync>
          </UserSettingsGate>
        </AuthProtection>
      </StoreProvider>
    </ErrorBoundary>,
  );
}

bootstrap();
